import { RouteRecordRaw } from 'vue-router';
import { RouterNames } from '../types';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/main-layout.vue'),
    children: [
      {
        path: '',
        name: RouterNames.HOME,
        component: () => import('pages/index.vue'),
        meta: {
          title: 'Home',
        },
      },
    ],
    meta: { requiresAuth: true },
  },
  {
    path: '/auth',
    component: () => import('layouts/blank-layout.vue'),
    children: [
      {
        path: 'login',
        name: RouterNames.LOGIN,
        component: () => import('pages/auth/login.vue'),
      },
      {
        path: 'auth-error',
        name: RouterNames.AUTH_ERROR,
        component: () => import('pages/auth/auth-error.vue'),
      },
    ],
  },
  {
    path: '/users',
    component: () => import('layouts/main-layout.vue'),
    children: [
      {
        path: '',
        name: RouterNames.USERS,
        component: () => import('pages/users/index.vue'),
        meta: {
          title: 'Users',
        },
      },
    ],
    meta: { requiresAuth: true },
  },
  {
    path: '/tasks',
    component: () => import('layouts/main-layout.vue'),
    children: [
      {
        path: '',
        name: RouterNames.TASKS,
        component: () => import('pages/tasks/index.vue'),
        meta: {
          title: 'Tasks',
        },
      },
    ],
    meta: { requiresAuth: true },
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue'),
  },
];

export default routes;
